// client/src/components/HomeHeader.js

import React, { useState, useEffect } from 'react';
import { Link, NavLink, useNavigate } from 'react-router-dom';
import { FiMenu, FiX } from 'react-icons/fi';

const LOGO_WIDE =
  'https://firebasestorage.googleapis.com/v0/b/ecobill-pay.firebasestorage.app/o/Administratif%2Flogo_allonge.png?alt=media&token=d253d70e-93fe-4de4-8417-132abb4e5f26';
const LOGO_SQUARE =
  'https://firebasestorage.googleapis.com/v0/b/ecobill-pay.firebasestorage.app/o/Administratif%2Flogo_ecobill_ok.png?alt=media&token=fc6a5deb-63aa-4b48-8427-301ff711a154';

const NAV_LINKS = [
  { to: '/homeclient', label: 'Utilisateurs' },
  { to: '/homecommercant', label: 'Commerçants' },
  { to: '/homeaffiliates', label: 'Affiliates' },
];

const HEADER_CSS = `
.lp-header {
  position: sticky; top: 0; z-index: 50;
  background: var(--eb-brand);
  border-bottom: 1px solid rgba(255, 255, 255, 0.08);
  box-shadow: 0 1px 0 rgba(15, 35, 56, 0.25), 0 8px 24px -16px rgba(15, 35, 56, 0.6);
}
.lp-header__inner {
  max-width: 1180px; margin: 0 auto; height: 72px;
  padding: 0 clamp(16px, 5vw, 32px);
  display: flex; align-items: center; justify-content: space-between; gap: 24px;
}
.lp-header__left { display: flex; align-items: center; gap: 36px; min-width: 0; }
.lp-header__logo { display: inline-flex; align-items: center; }
.lp-header__logo img { height: 52px; width: auto; display: block; }
.lp-header__nav { display: flex; align-items: center; gap: 4px; }
.lp-header__link {
  position: relative; padding: 8px 12px; border-radius: var(--eb-radius-sm);
  color: rgba(255, 255, 255, 0.78); text-decoration: none; font-size: 15px; font-weight: 500;
  transition: color 0.15s ease, background-color 0.15s ease;
}
.lp-header__link:hover { color: #fff; background: rgba(255, 255, 255, 0.08); }
.lp-header__link.active { color: #fff; }
.lp-header__link.active::after {
  content: ''; position: absolute; left: 12px; right: 12px; bottom: -2px; height: 2px;
  border-radius: 2px; background: var(--eb-cream);
}
.lp-header__actions { display: flex; align-items: center; gap: 8px; flex-shrink: 0; }
.lp-hbtn {
  display: inline-flex; align-items: center; justify-content: center;
  min-height: 40px; padding: 0 16px; border-radius: var(--eb-radius-pill);
  font-size: 14.5px; font-weight: 600; line-height: 1; text-decoration: none; white-space: nowrap;
  border: 1px solid transparent; cursor: pointer; font-family: inherit;
  transition: background-color 0.15s ease, color 0.15s ease, border-color 0.15s ease;
}
.lp-hbtn--ghost { background: transparent; color: #fff; border-color: rgba(255, 255, 255, 0.28); }
.lp-hbtn--ghost:hover { background: rgba(255, 255, 255, 0.1); color: #fff; border-color: rgba(255, 255, 255, 0.45); }
.lp-hbtn--solid { background: var(--eb-cream); color: var(--eb-brand-800); }
.lp-hbtn--solid:hover { background: #fff; color: var(--eb-brand-800); }
.lp-hbtn:focus-visible { outline: 2px solid var(--eb-cream); outline-offset: 2px; }

/* Mobile */
.lp-header--mobile .lp-header__inner { height: 64px; gap: 8px; }
.lp-header__burger {
  width: 44px; height: 44px; margin-left: -8px; border-radius: var(--eb-radius-sm);
  display: inline-flex; align-items: center; justify-content: center;
  background: transparent; border: 0; color: #fff; font-size: 24px; cursor: pointer;
}
.lp-header__burger:hover { background: rgba(255, 255, 255, 0.08); }
.lp-header--mobile .lp-header__logo { position: absolute; left: 50%; transform: translateX(-50%); }
.lp-header--mobile .lp-header__logo img { height: 44px; }
.lp-header--mobile .lp-hbtn { min-height: 36px; padding: 0 12px; font-size: 13.5px; }

.lp-drawer-backdrop {
  position: fixed; inset: 0; z-index: 1000;
  background: rgba(15, 35, 56, 0.55); backdrop-filter: blur(4px); -webkit-backdrop-filter: blur(4px);
  animation: lp-fade 0.2s ease both;
}
.lp-drawer {
  position: fixed; top: 0; left: 0; bottom: 0; z-index: 1001;
  width: min(320px, 86vw); background: var(--eb-surface);
  box-shadow: var(--eb-shadow-lg);
  display: flex; flex-direction: column; padding: 16px 20px 24px;
  animation: lp-slide 0.25s var(--eb-ease) both;
  overflow-y: auto;
}
.lp-drawer__top { display: flex; align-items: center; justify-content: space-between; margin-bottom: 16px; }
.lp-drawer__top img { height: 56px; width: auto; display: block; }
.lp-drawer__close {
  width: 44px; height: 44px; border-radius: var(--eb-radius-sm); border: 0; background: var(--eb-surface-2);
  color: var(--eb-text-2); font-size: 22px; display: inline-flex; align-items: center; justify-content: center; cursor: pointer;
}
.lp-drawer__nav { display: flex; flex-direction: column; gap: 2px; padding: 8px 0; border-top: 1px solid var(--eb-border); border-bottom: 1px solid var(--eb-border); }
.lp-drawer__link {
  display: flex; align-items: center; min-height: 48px; padding: 0 12px; border-radius: var(--eb-radius-sm);
  color: var(--eb-text); text-decoration: none; font-size: 16px; font-weight: 500;
}
.lp-drawer__link:hover, .lp-drawer__link.active { background: var(--eb-brand-50); color: var(--eb-brand); }
.lp-drawer__actions { display: flex; flex-direction: column; gap: 10px; margin-top: 20px; }
.lp-drawer__actions .lp-hbtn { min-height: 46px; font-size: 15px; width: 100%; }
.lp-drawer__actions .lp-hbtn--ghost { color: var(--eb-brand); border-color: var(--eb-border-strong); }
.lp-drawer__actions .lp-hbtn--ghost:hover { background: var(--eb-brand-50); color: var(--eb-brand); }
.lp-drawer__actions .lp-hbtn--solid { background: var(--eb-brand); color: #fff; }
.lp-drawer__actions .lp-hbtn--solid:hover { background: var(--eb-brand-700); color: #fff; }

@keyframes lp-fade { from { opacity: 0; } to { opacity: 1; } }
@keyframes lp-slide { from { transform: translateX(-100%); } to { transform: none; } }
@media (prefers-reduced-motion: reduce) { .lp-drawer, .lp-drawer-backdrop { animation: none; } }
`;

const HomeHeader = () => {
  const [isMobile, setIsMobile] = useState(window.innerWidth < 948);
  const [showDrawer, setShowDrawer] = useState(false);
  const navigate = useNavigate();

  useEffect(() => {
    const handleResize = () => setIsMobile(window.innerWidth < 948);
    window.addEventListener('resize', handleResize);
    return () => window.removeEventListener('resize', handleResize);
  }, []);

  return (
    <>
      <style>{HEADER_CSS}</style>
      {isMobile ? (
        <>
          <header className="lp-header lp-header--mobile">
            <div className="lp-header__inner" style={{ position: 'relative' }}>
              <button
                type="button"
                className="lp-header__burger"
                onClick={() => setShowDrawer(!showDrawer)}
                aria-label="Ouvrir le menu"
                aria-expanded={showDrawer}
              >
                <FiMenu />
              </button>

              <Link to="/" className="lp-header__logo" aria-label="Ecobill — accueil">
                <img src={LOGO_WIDE} alt="Logo Ecobill" />
              </Link>

              <Link to="/logingeneral" className="lp-hbtn lp-hbtn--ghost">
                Connexion
              </Link>
            </div>
          </header>

          {/* Menu de navigation en système de tiroir */}
          {showDrawer && (
            <>
              <div className="lp-drawer-backdrop" onClick={() => setShowDrawer(false)} />
              <nav className="lp-drawer" aria-label="Menu principal">
                <div className="lp-drawer__top">
                  <Link to="/" onClick={() => setShowDrawer(false)}>
                    <img src={LOGO_SQUARE} alt="Logo Ecobill" />
                  </Link>
                  <button
                    type="button"
                    className="lp-drawer__close"
                    onClick={() => setShowDrawer(false)}
                    aria-label="Fermer le menu"
                  >
                    <FiX />
                  </button>
                </div>

                <div className="lp-drawer__nav">
                  {NAV_LINKS.map(({ to, label }) => (
                    <NavLink key={to} to={to} onClick={() => setShowDrawer(false)} className="lp-drawer__link">
                      {label}
                    </NavLink>
                  ))}
                </div>

                <div className="lp-drawer__actions">
                  <Link to="/logingeneral" className="lp-hbtn lp-hbtn--ghost" onClick={() => setShowDrawer(false)}>
                    Connexion
                  </Link>
                  <button
                    type="button"
                    className="lp-hbtn lp-hbtn--solid"
                    onClick={() => navigate('/signup')}
                  >
                    Inscription
                  </button>
                </div>
              </nav>
            </>
          )}
        </>
      ) : (
        <header className="lp-header">
          <div className="lp-header__inner">
            <div className="lp-header__left">
              <Link to="/" className="lp-header__logo" aria-label="Ecobill — accueil">
                <img src={LOGO_WIDE} alt="Logo Ecobill" />
              </Link>
              <nav className="lp-header__nav" aria-label="Navigation principale">
                {NAV_LINKS.map(({ to, label }) => (
                  <NavLink key={to} to={to} className="lp-header__link">
                    {label}
                  </NavLink>
                ))}
              </nav>
            </div>
            <div className="lp-header__actions">
              <Link to="/logingeneral" className="lp-hbtn lp-hbtn--ghost">
                Connexion
              </Link>
              <button
                type="button"
                className="lp-hbtn lp-hbtn--solid"
                onClick={() => navigate('/signup')}
              >
                Inscription
              </button>
            </div>
          </div>
        </header>
      )}
    </>
  );
};

export default HomeHeader;
